import { render, staticRenderFns } from "./totalTurnover.vue?vue&type=template&id=05661dbc&scoped=true&"
import script from "./totalTurnover.vue?vue&type=script&lang=js&"
export * from "./totalTurnover.vue?vue&type=script&lang=js&"
import style0 from "./totalTurnover.vue?vue&type=style&index=0&id=05661dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05661dbc",
  null
  
)

export default component.exports